
  <div class="faq-container" [ngStyle]="{'background-color': us.trainerMode ? '#EFEFEF':'white' }">
    <div *ngIf="faqsLoaded && us.dataLoaded &&!trainerMode" class="user-mode-faqs">
     
    
      <ion-row *ngFor="let row of chunk(faqs, 2)">
        <ion-col *ngFor="let item of row" size="auto">
          <ion-card color="light" (click)="onCardClick(item.question)" class="user-ion-card card-flex"  [ngStyle]="{'background-color': us.trainerMode ? 'white':'#EFEFEF' }">
            <ion-img [src]="'assets/images/' + item.type + '.svg'"  class="user-mode-img"></ion-img>
            <ion-card-content>
              <h3 >{{ item.question }}</h3>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
   
    </div>
    <div *ngIf="faqsLoaded && us.dataLoaded && trainerMode" class="trainer-mode-faqs">
   
       <div class="img-container"><ion-img src="assets/images/trained-panda.svg"></ion-img>
    </div>
    <ion-grid>
      <ion-row *ngFor="let row of chunk(faqs, 2)">
        <ion-col *ngFor="let item of row" size="auto">
          <ion-card color="light" (click)="onCardClick(item.question)" class="trainer-ion-card card-flex" [ngStyle]="{'background-color': us.trainerMode ? 'white':'#EFEFEF' }">
            <ion-img [src]="'assets/images/' + item.type + '.svg'"  ></ion-img>
            <ion-card-content>
              <h3 >{{ item.question }}</h3>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
   </ion-grid>
    </div>
    <p *ngIf="!faqsLoaded && us.dataLoaded">No Faqs Found</p>
    <app-spinner *ngIf="!us.dataLoaded"></app-spinner>
  </div>

